import { BaseComponentLocator } from './base.component-locator';
export class LevelLocatorComponent extends BaseComponentLocator {
    constructor() {
        super(...arguments);
        this._id = null;
        this._group = null;
        this._isGroup = false;
    }
    toString() {
        let str = 'L';
        if (this.isGroup) {
            str += this.group;
        }
        else {
            if (this.id === null) {
                str += 'None';
            }
            else {
                str += this.id;
            }
        }
        return str;
    }
    /**
     * Level id setter/getter.
     */
    set id(levelId) {
        this._id = levelId;
        this._isGroup = false;
    }
    get id() {
        return this._isGroup ? null : this._id;
    }
    set group(groupLevel) {
        this._group = groupLevel;
        this._isGroup = true;
    }
    get group() {
        return this._isGroup ? this._group : null;
    }
    get isGroup() {
        return this._isGroup;
    }
}
